import { ModalConfirmAction } from '@repo/ui';
import { GetAllPersonProfileUseCaseInterface } from 'domain/usecases';
import { ACTIVE_STATUS } from 'domain/value-objects';
import { PersonProfilesTable } from 'presentation/app/modules/Person/components/person-profiles-table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { usePersonRegisterTab } from '../../../hooks';

interface IPersonProfilesSubTabProps {
  profiles: GetAllPersonProfileUseCaseInterface.Result;
  requestGetAllPersonProfile: (
    params: GetAllPersonProfileUseCaseInterface.Params,
  ) => void;
}

export const PersonProfilesSubTab = ({
  profiles,
  requestGetAllPersonProfile,
}: IPersonProfilesSubTabProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [profileId, setProfileId] = useState<number | null>(null);
  const [profileStatus, setProfileStatus] = useState<boolean | null>(null);

  const { id } = useParams();

  const {
    loadingActivateInactivateProfile,
    requestActivateInactivatePersonProfile,
  } = usePersonRegisterTab();

  function toggleModalActivateInactiveProfile() {
    setIsModalOpen(!isModalOpen);
  }

  const handleActiveInactiveSwitchChange = (
    profileId: number,
    checked: boolean,
  ) => {
    setProfileId(profileId);
    setProfileStatus(checked);
    toggleModalActivateInactiveProfile();
  };

  const isToActiveOrInactive = profileStatus
    ? ACTIVE_STATUS.ACTIVE
    : ACTIVE_STATUS.INACTIVE;

  return (
    <React.Fragment>
      <PersonProfilesTable
        data={profiles}
        handleActiveInactiveSwitchChange={handleActiveInactiveSwitchChange}
      />

      <ModalConfirmAction
        modalTheme="warning"
        featherIconName="alert-triangle"
        isOpen={isModalOpen}
        toggle={toggleModalActivateInactiveProfile}
        loading={loadingActivateInactivateProfile}
        title={`${profileStatus ? 'Ativar' : 'Inativar'} Perfil?`}
        subtitle={`Tem certeza que deseja ${profileStatus ? 'ativar' : 'inativar'} o perfil?`}
        actionBtnLabel={`${profileStatus ? 'Ativar' : 'Inativar'}`}
        onConfirm={() => {
          requestActivateInactivatePersonProfile(
            {
              id: String(profileId),
              activeStatus: isToActiveOrInactive,
            },
            () => {
              toggleModalActivateInactiveProfile();
              setProfileStatus(null);
              setProfileId(null);
              requestGetAllPersonProfile({ id });
            },
          );
        }}
        onClosed={() => {
          setProfileId(null);
          setProfileStatus(null);
        }}
      />
    </React.Fragment>
  );
};
